import { render, staticRenderFns } from "./piecingTrade.vue?vue&type=template&id=8bfc8202&scoped=true"
import script from "./piecingTrade.vue?vue&type=script&lang=js"
export * from "./piecingTrade.vue?vue&type=script&lang=js"
import style0 from "./piecingTrade.vue?vue&type=style&index=0&id=8bfc8202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc8202",
  null
  
)

export default component.exports